import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=382e0f7a&"
import script from "./Template.vue?vue&type=script&lang=js&"
export * from "./Template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382e0f7a')) {
      api.createRecord('382e0f7a', component.options)
    } else {
      api.reload('382e0f7a', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=382e0f7a&", function () {
      api.rerender('382e0f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Templates/Template.vue"
export default component.exports